import React, { useState } from 'react';
import "./ArticleCategorisation.css"
import ProgressBar from '../components/Plot/ProgressBar';
import CardHeader from '../components/CardHeader'
import Loader from '../components/Loader';

const ArticleCategorisation = () => {
    const defaultText = `Manchester City sweat on Erling Haaland ahead of key Liverpool clash in Premier League
    Reuters |
    Mar 31, 2023 07:31 AM IST
    
    Haaland is nursing a groin injury and missed training on Thursday as players returned from the international break.
    Manchester City fans are sweating on the fitness of goal machine Erling Haaland ahead of their key home Premier League game against Liverpool on Saturday.
    
    Manchester City's Erling Braut Haaland (REUTERS)
    Manchester City's Erling Braut Haaland (REUTERS)
    With Arsenal eight points clear of second-placed City, the champions need to take three from Juergen Klopp's side in the early kick-off to ensure the Gunners do not take their lead into double figures.
    
    Arsenal, who have 10 games remaining and are chasing a first championship since 2003-04, host 14th-placed Leeds United later on Saturday.
    
    Norwegian striker Haaland, who has scored an astonishing 42 goals in 37 matches for City since joining from Borussia Dortmund, is nursing a groin injury and missed training on Thursday as players returned from the international break.
    
    Haaland's father Alfie told Norwegian television last week it looked "touch and go" whether the striker would be back in time for the Liverpool game.
    
    "You can’t just go two weeks without training and then jump right into a fight," he said.
    
    City have a match in hand on the leaders but have played one more than third-placed Manchester United, who are at Newcastle United on Sunday and are 11 points further adrift.
    
    Palace are the only side in the league without a win in 2023, having drawn five and lost seven of their games.
    
    This story has been published from a wire agency feed without modifications to the text.
    `

    const defaultResult = [{ "label": "Sport", "score": 0 }, { "label": "World", "score": 0 }, { "label": "Technology", "score": 0 }, { "label": "Business", "score": 0 }]

    const [errorMessage, setErrorMessage] = useState(null)
    const [inputText, setInputText] = useState(defaultText);
    const [responseText, setResponseText] = useState(defaultResult);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://api-inference.huggingface.co/models/omgavy/bert-classifier-tuned',
                {
                    headers: { Authorization: `Bearer ${process.env.REACT_APP_API_KEY}` },
                    method: "POST",
                    body: JSON.stringify(inputText),
                }
            );
            const data = await response.json();
            const result = data.map((array) => {
                return array.map((object) => {
                    if (object.label === 'LABEL_0') {
                        return {
                            ...object,
                            label: 'World'
                        };
                    } else if (object.label === 'LABEL_1') {
                        return {
                            ...object,
                            label: 'Sport'
                        };
                    } else if (object.label === 'LABEL_2') {
                        return {
                            ...object,
                            label: 'Business'
                        };
                    } else if (object.label === 'LABEL_3') {
                        return {
                            ...object,
                            label: 'Technology'
                        };
                    } else {
                        return object;
                    }
                });
            });
            setErrorMessage(null)
            setResponseText(result[0]);
        } catch (error) {
            setErrorMessage("⚠️ Please try again in a minute. Model is loading ...")
            console.error(error);
        }
    };


    return (
        <div className='articlecategorisation__container' id='articlecategorisation'>
            <CardHeader
                title='Article Categorisation 🔖'
                subtitle="Categories articles using Natural Language Processing by pretrained BERT(uncased) model."
                link='https://github.com/OmgAvy/News-Article-Categorisation'
            />
            <form onSubmit={handleSubmit} className='nlpform__container' >
                <textarea
                    cols="30" rows="10" maxLength='2300'
                    value={inputText}
                    onChange={(e) => setInputText(e.target.value)}
                />
                <div className='cardbutton'>
                    <button type="submit" className='btn btn-primary' >⚡Compute⚡</button>
                    {errorMessage === null ? null : <Loader />}
                </div>
            </form>
            <div>
                <h5 style={{ color: 'var(--color-light)', margin: '1rem 0 1rem' }}>💡 Kindly attempt to truncate your articles as the current model is only trained to take 2300 characters. </h5>
                <text>{errorMessage}</text>
            </div><br />

            <div className='progressbar' >
                {responseText.map((result, index) => (
                    <div key={index}>
                        <div>{result.label}</div>
                        <ProgressBar progressValue={(result.score * 100).toFixed(2)} />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ArticleCategorisation